// Paymob API configuration - these should be moved to environment variables
const PAYMOB_BASE_URL = "https://accept.paymob.com";
const PAYMOB_SECRET_KEY =
  "egy_sk_live_87816ec2331687570e22591e79d0e0a5c982d0dba6a8d13367217419307c52a5";

const PAYMOB_SECRET_KEY_DEBUG =
  "egy_sk_test_912ec470acbccdb49389c2c86b2e871ecffb897afdd616dc501c703aee96f8bc";

const PAYMOB_PUBLIC_KEY = "egy_pk_live_ZpVcCsUIAM7IMcN2U3MhA9nugUAbiBfS";
const PAYMOB_PUBLIC_KEY_DEBUG = "egy_pk_test_E9OtdjHbrP6Lwt5xcnb4fyYz4LKAdfp2";
const PAYMOB_INTEGRATION_IDS = [5216494];
const PAYMOB_INTEGRATION_IDS_DEBUG = [5089488];
const PAYMOB_NOTIFICATION_URL =
  "https://erp-elsalab.odoo.com/api/cs/payments/paymob-hook";
const PAYMOB_REDIRECTION_URL = `${window.location.origin}/payment-success`;

// Create Paymob payment intention and get payment URL
export async function createPaymobPayment(
  orderId,
  amount,
  firstName,
  lastName,
  mobile,
  email
) {
  try {
    // Sanitize mobile: remove all non-digit characters
    const sanitizedMobile = mobile.replace(/\D/g, "").substring(0, 15);

    const response = await fetch(`${PAYMOB_BASE_URL}/v1/intention/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${PAYMOB_SECRET_KEY}`,
      },
      body: JSON.stringify({
        amount: Math.round(amount * 100), // Convert to piasters
        currency: "EGP",
        payment_methods: PAYMOB_INTEGRATION_IDS,
        items: [
          {
            name: orderId,
            amount: Math.round(amount * 100),
            quantity: "1",
            description: `${orderId}`,
          },
        ],
        billing_data: {
          apartment: "NA",
          first_name: firstName,
          last_name: lastName || "NA",
          street: "NA",
          building: "NA",
          phone_number: sanitizedMobile,
          city: "NA",
          country: "EG",
          email: email,
          floor: "NA",
          state: "NA",
        },
        customer: {
          first_name: firstName,
          last_name: lastName || "NA",
          email: email,
          extras: { re: orderId },
        },
        extras: { ee: orderId },
        notification_url: PAYMOB_NOTIFICATION_URL,
        redirection_url: PAYMOB_REDIRECTION_URL,
      }),
    });

    if (response.status !== 201) {
      let message = "";
      try {
        const j = await response.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await response.text().catch(() => "");
      }
      throw new Error(
        message ||
          `Failed to create payment intention with status ${response.status}`
      );
    }

    const decodedJson = await response.json();
    const clientSecret = decodedJson?.client_secret;
    if (!clientSecret) throw new Error("Client secret not returned by Paymob");

    // Return the unified checkout URL
    return `https://accept.paymob.com/unifiedcheckout/?publicKey=${PAYMOB_PUBLIC_KEY}&clientSecret=${clientSecret}`;
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while creating payment"
      : e?.message || "Failed to create payment";
    throw new Error(msg);
  }
}
